import React from 'react';
import {
  FuelGridContainer,
  FuelGridItem,
  FuelSkeleton,
} from '@frete.com/fuel-react';
import SkeletonOriginAndDestination from '@components/ui/Skeleton/SkeletonOriginAndDestination';
import { FuelFlex } from '@frete.com/fuel-station-react';
import * as StyledProposal from '../Proposal/ProposalStyles';
import * as Styled from './SkeletonStyles';

function Skeleton() {
  function renderLines() {
    const lines = 4;
    const components: React.ReactNode[] = [];

    for (let index = 0; index < lines; index += 1) {
      components.push(
        <StyledProposal.Wrapper
          key={`loading-proposals-${index}`}
          hasBorder={index + 1 !== lines}
        >
          <FuelGridContainer gapRow={16}>
            <FuelGridItem sm={2}>
              <Styled.WrapperTrucker>
                <FuelSkeleton
                  shape="circle"
                  size="custom"
                  width="40px"
                  height="40px"
                />
                <FuelFlex
                  defaultProps={{ flexDirection: 'column', gap: 'km2' }}
                >
                  <FuelSkeleton
                    shape="pill"
                    size="custom"
                    width="89px"
                    height="16px"
                  />
                  <FuelSkeleton
                    shape="pill"
                    size="custom"
                    width="59px"
                    height="16px"
                  />
                </FuelFlex>
              </Styled.WrapperTrucker>
            </FuelGridItem>
            <FuelGridItem sm={2}>
              <FuelFlex
                defaultProps={{
                  alignItems: 'flex-end',
                  flexDirection: 'column',
                  customPadding: '0 40px 0 0',
                }}
              >
                <FuelSkeleton
                  shape="square"
                  size="custom"
                  width="32px"
                  height="32px"
                />
              </FuelFlex>
            </FuelGridItem>
            <FuelGridItem sm={4}>
              <FuelSkeleton
                shape="pill"
                size="custom"
                width="150px"
                height="15px"
              />
            </FuelGridItem>
            <FuelGridItem sm={4}>
              <FuelFlex defaultProps={{ gap: 'km3' }}>
                <SkeletonOriginAndDestination />
                <FuelFlex
                  defaultProps={{ flexDirection: 'column', gap: 'km3' }}
                >
                  <FuelSkeleton
                    shape="pill"
                    size="custom"
                    width="89px"
                    height="16px"
                  />
                  <FuelSkeleton
                    shape="pill"
                    size="custom"
                    width="135px"
                    height="16px"
                  />
                </FuelFlex>
              </FuelFlex>
            </FuelGridItem>
            <FuelGridItem sm={4}>
              <FuelSkeleton
                shape="square"
                size="custom"
                width="100%"
                height="40px"
              />
            </FuelGridItem>
          </FuelGridContainer>
        </StyledProposal.Wrapper>,
      );
    }
    return components;
  }

  return <div data-testid="loading-proposals-mobile">{renderLines()}</div>;
}

export default Skeleton;
